/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import { CSSProperties, useEffect, useState } from 'react';
import { Input as InputAntD } from 'antd';
import InputErrorIcon from "@assets/icons/input-error.svg"

const styles = {
  height: '40px',
  border: '1px solid #E4D7CD !important',
}

interface IInput {
  onChange?: (value: string) => void;
  style?: CSSProperties;
  [key: string]: any;
}

const Input = ({ height, name, form, onChange, ...props}: IInput) => {
  const [hasError, setHasError] = useState(false);
  const suffix = hasError ? <img src={InputErrorIcon} alt="error" /> : <span />;

  useEffect(() => {
    if(form) {
      const currentErrors = form.getFieldError(name);
      setHasError(currentErrors.length > 0);
    }
  }, [form?.getFieldError(name)]);

  return (
    <InputAntD
      autoComplete="random-string"
      styles={{
        input: {
          ...styles,
          ...(height && {height: height})
        },
      }}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange?.(e.target.value)}
      suffix={suffix}
      {...props}
    />
  )
};

Input.Password = ({ name, form, onChange, ...props }: IInput) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if(form) {
      const currentErrors = form.getFieldError(name);
      setHasError(currentErrors.length > 0);
    }
  }, [form.getFieldError(name)]);

  return (
    <div style={{ position: "relative" }}>
      <InputAntD.Password
        styles={{
          affixWrapper: styles
        }}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange?.(e.target.value)}
        {...props}
      />
      {hasError && <img src={InputErrorIcon} alt="error" style={{ position: "absolute", top: "12px", right: "30px", zIndex: "999" }} />}
    </div>
  )
};

Input.TextArea = ({ onChange, ...props }: IInput) => {
  return (
    <InputAntD.TextArea
      styles={{
        textarea: {border: '1px solid #E4D7CD !important', minHeight: "130px"}
      }}
      onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => onChange?.(e.target.value)}
      {...props}
    />
  )
};

export default Input
